__webpack_require__.p = "https://bmidxbromaniaplpreprod.netlify.app/";